import { render, staticRenderFns } from "./Lojistas.vue?vue&type=template&id=1cb3bd5e"
import script from "./Lojistas.vue?vue&type=script&lang=js"
export * from "./Lojistas.vue?vue&type=script&lang=js"
import style0 from "./Lojistas.vue?vue&type=style&index=0&id=1cb3bd5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports